:host {
  @-webkit-keyframes fadein {
    from {
      opacity: 0;
      transform: translate(600px, 0);
    }

    to {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  @-moz-keyframes fadein {
    from {
      opacity: 0;
      transform: translate(600px, 0);
    }

    to {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  @keyframes fadein {
    from {
      opacity: 0;
      transform: translate(600px, 0);
    }

    to {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  .background-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.23);
  }

  .hide {
    display: none;
  }

  .flex {
    display: flex;
  }

  .button-secondary {
    background-color: #f1f1f1 !important;
    color: rgb(51, 51, 51) !important;
  }

  .separator {
    &__header {
      height: 1px;
      background: #f5f5f5;
      width: 100%;
      position: absolute;
      top: 60px;
      left: 0;
    }
  }

  .main-modal {
    position: fixed;
    width: 600px;
    right: 0;
    top: 0;
    cursor: default !important;
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 90px 0 40px;
    background-color: white;
    border: 0;
    border-radius: 0;
    box-shadow:
      0 10px 10px rgba(0, 0, 0, 0.19),
      0 6px 6px rgba(0, 0, 0, 0.23);
    -webkit-animation: fadein 0.2s ease-out normal 1;
    -moz-animation: fadein 0.2s ease-out normal 1;
    animation: fadein 0.2s ease-out normal 1;
    z-index: 1001;

    @media screen and (max-width: 768px) {
      width: 100vw;
    }

    &__init-loader {
      margin-top: 50%;
    }

    &__closing {
      padding: 90px 40px 40px;

      -webkit-animation: fadein 0.2s ease-out normal 1;
      -moz-animation: fadein 0.2s ease-out normal 1;
      animation: fadein 0.2s ease-out normal 1;

      -moz-animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;

      -moz-animation-direction: reverse;
      -webkit-animation-direction: reverse;
      animation-direction: reverse;

      @media screen and (max-width: 768px) {
        width: 100vw;
      }
    }

    .drop-overlay {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      position: absolute;
      background: #ffffffe3;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      opacity: 0;
      pointer-events: none;
      transition: opacity ease 0.2s;

      &__active {
        opacity: 1;
      }
    }

    &__close {
      display: flex;
      position: absolute;
      top: 40px;
      transform: translateY(-50%);
      right: 25px;
      cursor: pointer;

      img {
        filter: invert(39%) sepia(0%) saturate(851%) hue-rotate(216deg) brightness(98%)
          contrast(85%);
        width: 18px;
      }
    }

    &__title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 10px;
      top: 40px;
      left: 25px;
      transform: translateY(-50%);
      position: absolute;
      color: #333;
    }

    .header {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      margin-bottom: 32px;
      &.no-margin {
        margin-bottom: 0;
      }
      .circle-icon {
        background: #ff8500;
        width: 18px;
        height: 18px;
        margin-right: 16px;
        border-radius: 50%;
        text-align: center;
        line-height: 100px;
        vertical-align: middle;
        padding: 10px;
        &.green {
          background: #3ebf4d;
        }
        &.blue {
          background: #0098ff;
        }
      }
      &__title {
        color: #333;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 8px;
      }
      &__description {
        color: #666;
        font-size: 14px;
        font-weight: 400;
        white-space: normal !important;
      }
      &__chevron {
        margin: auto;
        width: 13px;
        height: 13px;
        cursor: pointer;
        transform: rotate(90deg);
        transition: all 0.3s;
        &.report-open {
          transform: rotate(-90deg);
        }
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      margin: 0 25px 32px;
      padding: 20px;
      border: 1px solid #e0e0e0;
      border-radius: 10px;

      .report-content {
        display: none;
        &.report-open {
          display: block;
        }
      }

      .user-informations {
        display: flex;
        flex-direction: column;
        margin-bottom: 30px;

        .user-informations-left {
          width: 50%;
          padding-right: 15px;
          box-sizing: border-box;
        }

        .user-informations-right {
          width: 50%;
          padding-left: 15px;
          box-sizing: border-box;
        }

        &__title {
          font-weight: 500;
          font-size: 16px;
          margin-bottom: 10px;
        }

        &__informations {
          display: flex;
          flex-direction: column;

          .information {
            display: flex;

            .information-title {
              font-weight: 500;
              margin-right: 10px;
              white-space: nowrap;
            }

            .information-description {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      &.external-choice {
        margin-top: 32px;
        background-color: #fafafa;
        border: unset;
        cursor: pointer;
        &:hover {
          background-color: #f4f6fd;
          .header__chevron {
            display: none;
            &.chevron-on-hover {
              display: block;
            }
          }
        }
        .header {
          margin-bottom: 0;
          &__chevron {
            transform: rotate(0deg);
          }
          .chevron-on-hover {
            display: none;
          }
        }
      }

      .form {
        .form-row {
          display: flex;
          margin-bottom: 15px;

          @media screen and (max-width: 768px) {
            flex-direction: column;
            row-gap: 15px;
          }
        }

        .form-type,
        .form-project,
        .form-priority {
          margin-right: 15px;
          font-weight: 300 !important;
          color: #666;
          height: 40px !important;
          line-height: 40px !important;

          @media screen and (max-width: 768px) {
            margin-right: 0;
          }

          .form-select__title {
            font-weight: 400 !important;
            color: #666;
            line-height: normal !important;

            &.ik-form__title--focus {
              top: 0 !important;

              @media screen and (max-width: 990px) {
                top: 0 !important;
              }
            }
          }

          select {
            border: 1px solid #d5d5d5;
            max-width: 216px !important;

            @media screen and (max-width: 768px) {
              width: 100%;
              max-width: 100% !important;
            }
          }
        }

        .partner-box {
          display: flex;
          align-items: flex-start;
          margin-bottom: 15px;
          padding: 18px 30px 18px 0;
          background-color: #f4f6fd;
          border-radius: 5px;
          color: #333;
          white-space: normal !important;
          img {
            width: 16px;
            margin: 3px 14px 0 14px;
          }
          .partner-content {
            font-size: 14px;
            font-weight: 400;
          }
        }

        .ik-form__title {
          pointer-events: none;
        }

        .form-subject {
          margin-bottom: 15px;
          height: 40px !important;
          line-height: 40px !important;

          &__title {
            font-weight: 400 !important;
            color: #666;
            line-height: normal !important;

            &.ik-form__title--focus {
              top: 0 !important;

              @media screen and (max-width: 990px) {
                top: 0 !important;
              }
            }
          }

          &__input {
            width: 100%;
            box-sizing: border-box;
            border: 1px solid #d5d5d5;
          }
        }

        .form-link {
          margin-bottom: 15px;
          height: 40px !important;
          line-height: 40px !important;

          &__title {
            font-weight: 400 !important;
            color: #666;
            line-height: normal !important;

            &.ik-form__title--focus {
              top: 0 !important;

              @media screen and (max-width: 990px) {
                top: 0 !important;
              }
            }
          }

          &__input {
            width: 100%;
            box-sizing: border-box;
            border: 1px solid #d5d5d5;
          }
        }

        .form-description {
          margin-bottom: 15px;

          &__title {
            font-weight: 400 !important;
            color: #666;
            line-height: normal !important;

            &.ik-form__title--focus {
              top: 0 !important;
            }
          }

          &__textarea {
            min-height: 100px;
            width: 100%;
            box-sizing: border-box;
            border: 1px solid #d5d5d5;
            resize: vertical;
          }
        }

        .mail-product-files {
          &__title {
            color: #333333;
            // color: var(--font-primary);
            font-size: 15px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 21px;
          }

          &__description {
            color: #666666;
            // color: var(--font-secondary);
            font-size: 12px;
            letter-spacing: 0;
            line-height: 14px;
            margin-bottom: 20px;
            width: 100% !important;
            white-space: normal !important;

            .error {
              color: red;
              padding-top: 5px;
            }

            .jauge__container {
              display: inline-block;
              margin-right: 16px;
              background-color: #f3f3f3;
              width: 130px;
              border-radius: 20px;
              height: 8px;

              &--fill {
                background-color: #00bcd4;
                border-radius: 20px;
                height: 8px;
                margin: 0;
                width: 0;
                transition: width ease 0.3s;

                &--error {
                  background-color: #ff7d7d;
                }
              }
            }
          }

          &__files {
            .file-container {
              position: relative;
              display: flex;
              // border: 2px dashed #e0e0e0;
              // border: 2px dashed var(--divider);
              margin-bottom: 20px;
              height: 100%;
              flex-wrap: wrap;
              font-weight: 300 !important;
              font-size: 12px;
              color: #666;

              .file-text {
                line-height: 15px;
              }

              img {
                width: 14px;
                height: 14px;
                object-fit: contain;
                margin-right: 20px;
                filter: invert(9%) sepia(5%) saturate(560%) hue-rotate(201deg) brightness(92%)
                  contrast(94%);
                filter: var(--icon-bg-primary--invert);
              }

              a {
                text-decoration: none;
                color: #0098ff;
                color: var(--blue);
              }

              .file {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-direction: row;
                width: 100%;
                margin-bottom: 8px;
                box-sizing: border-box;
                background-color: #f4f6fd;
                border-radius: 6px;
                padding: 5px 16px;
                height: 28px !important;

                &__size {
                  color: #a3a3a3;
                  font-weight: 300 !important;
                }

                img {
                  width: 14px;
                  height: 14px;
                  margin-right: 0;
                }

                &__close {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  align-self: center;

                  img {
                    cursor: pointer;
                    position: relative;
                    width: 18px;
                    height: 18px;
                    margin: 0;
                    object-fit: contain;
                    filter: invert(19%) sepia(16%) saturate(0%) hue-rotate(157deg) brightness(94%)
                      contrast(95%);
                    filter: brightness(3.5);
                  }
                }

                &__title {
                  font-weight: 500;
                  line-height: normal !important;
                  color: #666;
                  font-size: 12px;
                  padding-left: 10px;
                  letter-spacing: 0;
                  text-overflow: ellipsis;
                  width: 450px;
                  white-space: nowrap;
                  overflow: hidden;

                  &--clickable {
                    cursor: pointer;
                  }
                }
              }

              .upload {
                background: #0098ff;
                background: var(--blue);
                width: 36px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                // color: var(--font-primary--invert);
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                border-radius: 4px;
                cursor: pointer;

                &:hover {
                  transition: background 0.3s;
                  background: #007ee2;
                  background: var(--blue-hover);
                }
              }
            }

            &--hover {
              .file-container {
                border-color: #0098ff;
                border-color: var(--blue);
              }
            }
          }

          &__info {
            display: flex;
            border-radius: 4px;
            background-color: #0098ff;
            background-color: var(--blue);
            color: white;
            padding: 15px;
            box-sizing: border-box;
            margin-bottom: 30px;

            img {
              width: 20px;
              height: 20px;
              object-fit: contain;
              margin-right: 10px;
              filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
                contrast(105%);
              filter: var(--icon-white);
            }

            p {
              margin: 0;
            }
          }
        }

        .form-actions {
          display: flex;
          margin-bottom: 15px;
          background-color: #fafafa;
          border-radius: 10px;
          line-height: normal !important;

          &__screenshot,
          &__file,
          &__record {
            button {
              background-color: #fafafa;
              display: flex;

              &:hover {
                background-color: #e0dfdf;
              }

              img {
                filter: opacity(0.7);
              }

              .screenshot-indicator {
                font-size: 12px;
                letter-spacing: 0;
                line-height: 18px;
                padding-left: 10px;
                font-weight: 300;
                color: var(--blue);
              }
            }

            &.tooltip {
              .tooltiptext {
                left: 0;
                bottom: -100%;
                background: #333;
                color: #fff;
                width: max-content;
                padding: 10px 20px;
                font-size: 14px;
                line-height: normal !important;

                &::after {
                  display: none;
                }
              }
            }
          }
        }
      }
    }

    &__actions {
      display: flex;
      justify-content: space-between;

      &--result {
        flex-direction: column;
        justify-content: center;
        display: flex;
        align-items: center;
        color: #333;
        font-weight: 300 !important;
        line-height: normal !important;

        div {
          text-align: center;
          font-weight: 300 !important;
          color: #666;
          line-height: normal !important;
          white-space: normal;
          width: 100%;
          font-size: 14px !important;
        }
        .success-partner-message {
          width: 80%;
        }
      }
    }
  }

  .logs-container {
    max-height: 100px;
    overflow: scroll;
    display: flex;
    flex-direction: column;
  }

  .error-message {
    background: #fff2f1;
    color: red;
    border-radius: 10px;
    padding: 10px 20px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 300 !important;
    line-height: normal !important;
    white-space: normal !important;
  }

  .button-disabled {
    background-color: var(--bg-secondary);
    color: var(--bg-disabled-button);
    cursor: not-allowed;
  }

  .button__close {
    margin-top: 40px;
  }

  .result__image {
    width: 230px;
    height: 190px;
    margin-bottom: 20px;
  }

  .capture-preview {
    padding: 12px;
    border-radius: 6px;
    background: white;
    position: absolute;
    top: calc(100vh - 200px);
    right: 620px;
    z-index: 1;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.19);
    cursor: pointer;

    img {
      border-radius: 10px;
    }
  }
}
